import EventContainer from './event_container';

const Event = EventContainer;
export default Event;
